import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Danhmuctuyenxebuyt from "components/Danhmuc/Tuyenxebuyt/Danhmuctuyenxebuyt.js";
export default function Dmtuyenxe() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Danh mục tuyến xe buýt",
            tabContent: <Danhmuctuyenxebuyt />,
          },
        ]}
      />
    </div>
  );
}
